import React from "react";

export default function BrandLoadingScreen({ message = "Loading LiteRent...", fullScreen = true, compact = false }) {
  const wrapperClass = fullScreen
    ? "min-h-screen flex items-center justify-center bg-gradient-to-br from-[#f8fbff] via-white to-[#f5f9ec] px-6"
    : "flex items-center justify-center py-10 px-4";

  return (
    <div className={wrapperClass}>
      <div className={`w-full ${compact ? "max-w-xs" : "max-w-sm"} rounded-[2rem] border border-[#e8f2d1] bg-white/95 backdrop-blur shadow-[0_24px_80px_rgba(41,76,121,0.16)] p-6 sm:p-8 text-center`}>
        <div className="mx-auto mb-5 w-full max-w-[220px] overflow-hidden rounded-[1.5rem] bg-[#f8fbff] border border-[#edf2f7]">
          <video
            src="/videos/loading-animation.mp4"
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover"
          />
        </div>
        <p className="text-lg font-semibold text-[#294c79]">Please hold on</p>
        <p className="mt-2 text-sm text-[#1a1a1a]/65 leading-relaxed">{message}</p>
      </div>
    </div>
  );
}
